export default __webpack_public_path__ + "static/media/correct.3dab0c97.svg";